import * as React from 'react';

export interface IQuantitySelect {
    quantity: number;
    canAdd: boolean;
    canRemove: boolean;
    onSelectQuantity: (newQuantity) => void;
    componentClassName: string;
};

interface IDataLoaderState {
    loadingText: string;
    showStopAnimationButton: boolean;
    showAnimation: boolean;
    timeout: any;
};

class QuantitySelect extends React.PureComponent<IQuantitySelect, IDataLoaderState> {
    constructor(props) {
        super(props);
    }

    render() {
        var disabledMinusClass = this.props.canRemove ? "" : "disabled";
        var disabledPlusClass = this.props.canAdd ? "" : "disabled";


        return (
            <div className={this.props.componentClassName}>
                <button className={`ticket-selection-quantity minus ${disabledMinusClass}`}
                    value="-"
                    onClick={this._onMinusClick.bind(this)}>
                    <svg dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-minus" />' }} />
                </button>
                <p className="seat-info-prices-qty">{this.props.quantity}</p>

                <button className={`ticket-selection-quantity ${disabledPlusClass}`}
                    value="+"
                    onClick={this._onPlusClick.bind(this)}>
                    <svg dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-plus" />' }} />
                </button>
            </div>
        );
    }

    _onPlusClick() {
        if (this.props.canAdd) {
            const newQuantity = this.props.quantity + 1;
            this.props.onSelectQuantity(newQuantity);
        }
    }

    _onMinusClick() {
        if (this.props.canRemove) {
            const newQuantity = this.props.quantity - 1;
            this.props.onSelectQuantity(newQuantity);
        }
    }
}

export default QuantitySelect;